import { injectFields, injectMethods, vueLinkLocalStorage } from '../../utils/vue';
import { INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from '../../utils/consts';
import ExprInputCompletionProvider from '../../comps/ExprInput/ExprInputCompletionProvider';
import StylePanel from './StylePanel';
import EventPanel from './EventPanel';
import PropPanel from "./components/PropPanel";
import RenderCondition from "./components/RenderCondition";
import { EventPanelNew } from "../../../lib/comps/PropPanel/EventPanelNew";
const __script_base__ = {
  name: 'CPropPanel',
  inject: {
    uc: {
      from: INJECT_UICORE_BUS,
      default: null
    },
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  },
  data() {
    return {
      activeKey: 'prop'
    };
  },
  components: {
    StylePanel,
    EventPanel,
    PropPanel,
    ExprInputCompletionProvider,
    RenderCondition,
    EventPanelNew
  },
  created() {
    vueLinkLocalStorage(this, 'propPanel', 'activeKey');
  },
  computed: {
    tabs() {
      const {
        renderer
      } = this.designer;
      /** @type {UICore.LayoutErrors} */
      const errors = renderer.ucLayoutErrors[this.compPath];
      const isLogicComponent = /\/@triggers\/\d+$/.test(this.compPath); // @triggers

      if (isLogicComponent) {
        return [{
          id: 'trigger',
          title: '触发器属性和行为',
          badgeText: errors && errors.length
        }];
      }
      const panelList = [{
        id: 'prop',
        title: '属性',
        badgeText: errors && errors.filter(x => x.category === 'prop').length
      }, {
        id: 'style',
        title: '样式'
      }, {
        id: 'event',
        title: '行为',
        badgeText: errors && errors.filter(x => x.category === 'event').length
      }];
      const {
        propPanelFilter
      } = this.uc.config.designerUiConfig;
      return panelList.filter(propPanelFilter);
    },
    ...injectFields('designer', ['compPath', 'activeComp', 'activeCompMeta'])
  },
  watch: {
    tabs(tabs) {
      if (!tabs.some(x => x.id === this.activeKey)) this.activeKey = tabs[0].id;
    }
  },
  methods: {
    ...injectMethods('designer', ['getCompAtPath', 'setHighlight', 'deleteActiveComp', 'modifyActiveComp']),
    handleCaptureBlur() {
      this.uc.flushPageletsChange();
    },
    getDataStubOfRenderer() {
      return this.designer.renderer.ucDataStub;
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucdProps"
  }, [_c("div", {
    staticClass: "ucdProps_tabs uc-tabs-list nowrap isDark withShortIndicator"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c("div", {
      key: tab.id,
      staticClass: "uc-tabs-item",
      class: {
        isActive: tab.id === _vm.activeKey
      },
      attrs: {
        "data-ucd-report-eid": tab.title,
        tabindex: "0"
      },
      on: {
        click: function ($event) {
          _vm.activeKey = tab.id;
        }
      }
    }, [_c("div", {
      staticClass: "uc-tabs-item-text"
    }, [_vm._v("\n        " + _vm._s(tab.title) + "\n        "), tab.badgeText ? _c("div", {
      staticClass: "uc-tabs-item-badge"
    }, [_vm._v("\n          " + _vm._s(tab.badgeText) + "\n        ")]) : _vm._e()])]);
  }), 0), _vm._v(" "), _c("ExprInputCompletionProvider", {
    attrs: {
      "data-stub": _vm.getDataStubOfRenderer
    }
  }, [_vm.activeComp && _vm.activeCompMeta ? _c("div", {
    key: _vm.compPath,
    staticClass: "ucdProps_content",
    class: {
      ucdProps_content_miniScroll: _vm.activeKey === "event" || _vm.activeKey === "trigger",
      noPadding: _vm.activeKey === "style"
    },
    attrs: {
      "data-current": _vm.activeKey
    },
    on: {
      blur: _vm.handleCaptureBlur,
      click: _vm.handleCaptureBlur
    }
  }, [_vm.activeKey === "event" || _vm.activeKey === "trigger" ? _c("RenderCondition", {
    key: "condition",
    attrs: {
      "comp-path": _vm.compPath
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeKey === "prop" || _vm.activeKey === "trigger" ? _c("PropPanel", {
    key: "prop",
    attrs: {
      "comp-path": _vm.compPath
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeKey === "style" ? _c("StylePanel", {
    key: "style",
    attrs: {
      "comp-path": _vm.compPath,
      "show-panel-name": _vm.activeKey
    }
  }) : _vm._e(), _vm._v(" "), _vm.activeKey === "event" || _vm.activeKey === "trigger" ? _c("EventPanelNew", {
    key: "EventPanelNew",
    attrs: {
      "comp-path": _vm.compPath
    }
  }) : _vm._e()], 1) : _vm._e()])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);